<template>
  <!-- Employee Basic Info View -->
  <div class="tabs-content-firstblock mb-4">
    <div class="row">
      <div class="col-lg-12">
        <div class="infoHeader ml-2 mr-1">
          <div class="descriptionheader">
            <div class="description-text-header-left">
              <h5>
                <i class="crmnew-basic iconsize-16 pr-1 defaultBlue"></i>
                Basic Information
              </h5>
            </div>
          </div>
        </div>
        <div class="ml-2 mr-1">
          <div class="row" v-if="businessData">
            <div class="col-lg-12">
              <div class="a-q-Jc-j-contactView mt-1">
                <div class="a-q-Jc-Pj-Ya-contactView">
                  <div class="a-q-Jc-bj-contactView defaultBlue">First Name</div>
                  <div class="a-q-Jc-Lb-contactView">
                    <span class="a-q-Jc-wg-contactView font-color">{{ businessData.first_name.value }}</span>
                  </div>
                </div>
              </div>
              <div class="a-q-Jc-j-contactView">
                <div class="a-q-Jc-Pj-Ya-contactView">
                  <div class="a-q-Jc-bj-contactView defaultBlue">Middle Name</div>
                  <div class="a-q-Jc-Lb-contactView">
                    <span
                      class="a-q-Jc-wg-contactView text-runcate"
                    >{{ businessData.middle_name ? businessData.middle_name.value : "-" }}</span>
                  </div>
                </div>
              </div>
              <div class="a-q-Jc-j-contactView">
                <div class="a-q-Jc-Pj-Ya-contactView">
                  <div class="a-q-Jc-bj-contactView defaultBlue">Last Name</div>
                  <div class="a-q-Jc-Lb-contactView">
                    <span class="a-q-Jc-wg-contactView">{{ businessData.last_name ? businessData.last_name.value : "-" }}</span>
                  </div>
                </div>
              </div>
              <div class="a-q-Jc-j-contactView">
                <div class="a-q-Jc-Pj-Ya-contactView">
                  <div class="a-q-Jc-bj-contactView defaultBlue">Gender</div>
                  <div class="a-q-Jc-Lb-contactView">
                    <span
                      class="a-q-Jc-wg-contactView"
                      v-if="businessData.gender"
                    >{{ businessData.gender ? businessData.gender.value : "-" }}</span>
                  </div>
                </div>
              </div>
              <div class="a-q-Jc-j-contactView">
                <div class="a-q-Jc-Pj-Ya-contactView">
                  <div class="a-q-Jc-bj-contactView defaultBlue">
                    Date of Birth
                    <br />(dd/mm/yyyy)
                  </div>
                  <div class="a-q-Jc-Lb-contactView mt-3">
                    <span
                      class="a-q-Jc-wg-contactView"
                      v-if="businessData.date_of_birth"
                    >{{ businessData.date_of_birth.value && businessData.date_of_birth.value != null ? moment(businessData.date_of_birth.value).format('DD/MM/YYYY') : "-" }}</span>
                    <span class="a-q-Jc-wg-contactView mt-5" v-else>-</span>
                  </div>
                </div>
              </div>
              <!-- <div class="a-q-Jc-j-contactView">
                <div class="a-q-Jc-Pj-Ya-contactView">
                  <div class="a-q-Jc-bj-contactView defaultBlue">Personal Email</div>
                  <div class="a-q-Jc-Lb-contactView">
                    <span class="a-q-Jc-wg-contactView">{{ businessData.primary_email.value }}</span>
                  </div>
                </div>
              </div> -->
              <div class="a-q-Jc-j-contactView">
                <div class="a-q-Jc-Pj-Ya-contactView">
                  <div class="a-q-Jc-bj-contactView defaultBlue">Business Email</div>
                  <div class="a-q-Jc-Lb-contactView">
                    <span class="a-q-Jc-wg-contactView">{{ businessData.primary_email.value }}</span>
                  </div>
                </div>
              </div>
              <div class="a-q-Jc-j-contactView">
                <div class="a-q-Jc-Pj-Ya-contactView">
                  <div class="a-q-Jc-bj-contactView defaultBlue">Phone Number</div>
                  <div class="a-q-Jc-Lb-contactView">
                    <span
                      class="a-q-Jc-wg-contactView"
                      v-if="businessData.primary_phone"
                    >{{ businessData.primary_phone.value.phone_number || '-' }}</span>
                    <span class="a-q-Jc-wg-contactView" v-else>-</span>
                  </div>
                </div>
              </div>
              <div class="a-q-Jc-j-contactView">
                <div class="a-q-Jc-Pj-Ya-contactView">
                  <div class="a-q-Jc-bj-contactView defaultBlue">Blood Group</div>
                  <div class="a-q-Jc-Lb-contactView">
                    <span class="a-q-Jc-wg-contactView">{{ businessData.health ? businessData.health.value.blood_group : '-' }}</span>
                  </div>
                </div>
              </div>
              <div class="a-q-Jc-j-contactView">
                <div
                  class="a-q-Jc-Pj-Ya-contactView"
                  style="border-bottom: solid 1px transparent !important;"
                >
                  <div class="a-q-Jc-bj-contactView defaultBlue">User Access</div>
                  <div class="a-q-Jc-Lb-contactView">
                    <span class="a-q-Jc-wg-contactView" v-if="businessData.is_admin">Admin</span>
                    <span
                      class="a-q-Jc-wg-contactView"
                      v-else-if="businessData.is_superadmin"
                    >Super Admin</span>
                    <span class="a-q-Jc-wg-contactView" v-else>User</span>
                  </div>
                </div>
              </div>
              <div v-if="businessData.hasOwnProperty('reporting_manager')" class="a-q-Jc-j-contactView">
                <div class="a-q-Jc-Pj-Ya-contactView">
                  <div class="a-q-Jc-bj-contactView defaultBlue">Reporting Manager</div>
                  <div class="a-q-Jc-Lb-contactView">
                    <span class="a-q-Jc-wg-contactView">{{ businessData.reporting_manager.full_name }}</span>
                  </div>
                </div>
              </div>
              <div class="a-q-Jc-j-contactView">
                <div
                  class="a-q-Jc-Pj-Ya-contactView"
                  style="border-bottom: solid 1px transparent !important;"
                >
                  <div class="a-q-Jc-bj-contactView defaultBlue">Signature Name</div>
                  <div class="a-q-Jc-Lb-contactView">
                    <span class="a-q-Jc-wg-contactView">{{ businessData.signature ? businessData.signature.name : '-' }}</span>
                  </div>
                </div>
              </div>
              <div class="a-q-Jc-j-contactView">
                <div
                  class="a-q-Jc-Pj-Ya-contactView"
                  style="border-bottom: solid 1px transparent !important;"
                >
                  <div class="a-q-Jc-bj-contactView defaultBlue">Signature</div>
                  <div class="a-q-Jc-Lb-contactView" v-if="'signature' in businessData && businessData.signature.signature_url">
                    <img
                      :src="businessData.signature.signature_url"
                      alt="signature"
                      style="width: 100%; height: 150px"
                    />
                  </div>
                  <div class="a-q-Jc-Lb-contactView" v-else>
                    <span class="a-q-Jc-wg-contactView">-</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.grey-border-box {
  border: dashed 0px transparent;
  padding: 11px 20px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.92;
  letter-spacing: 0.56px;
  text-align: center;
  color: #00448b;
  width: 265px;
  margin: 0 auto;
  border-radius: 12px;
}
</style>
<script>
import moment from "moment";
import { User } from "./mixins/user";
import { EventBus } from "./eventBus/nav-bar-event.js";
export default {
  data() {
    return {};
  },
  mixins: [User],
  methods: {
    moment(date) {
      return moment(date);
    },
  },
  props: ["businessData"],
};
</script>


// WEBPACK FOOTER //
// src/components/EmployeeBasicView.vue